"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OSDInstance = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const openseadragon_1 = __importDefault(require("openseadragon"));
const axios_1 = __importDefault(require("axios"));
const uuid_1 = require("uuid");
require("./osd-instance.scss");
const OSDInstance = (props) => {
    const [instance, setInstance] = (0, react_1.useState)();
    const [viewerWidthHeight, setViewerWidthHeight] = (0, react_1.useState)({ w: "", h: "" });
    const [viewerId] = (0, react_1.useState)((0, uuid_1.v4)());
    (0, react_1.useEffect)(() => {
        if (props.coords && !props.constrainViewerToCoords) {
            setViewerWidthHeight(computeViewerWidthHeight(props.coords.split(",")[2], props.coords.split(",")[3]));
        }
        else {
            setViewerWidthHeight(computeViewerWidthHeight(props.viewerWidth, props.viewerHeight));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.coords, props.viewerWidth, props.viewerHeight, props.constrainViewerToCoords]);
    (0, react_1.useEffect)(() => {
        axios_1.default.get(props.imageurl + "/info.json").then((d) => {
            // if instance is already created; don't create a new one but adjust properties as needed
            if (instance) {
                // Modify tile source as needed to already existing instance
                instance.addTiledImage({
                    tileSource: d.data
                });
                // if coords are present calculate coord rect
                if (props.coords) {
                    // this should be another way to get Scalar coordinates, but it doesn't seem to be working
                    //const newRect = instance.viewport.imageToViewportRectangle(x, y, w, h)
                    const sc = getScalarCoordinates(props.coords, d.data.height, d.data.width);
                    const rect = new openseadragon_1.default.Rect(sc.x, sc.y, sc.w, sc.h);
                    // if constrainViewerToCoords is false (default) constrain view to coordinate region
                    if (!props.constrainViewerToCoords) {
                        setBounds(instance, rect);
                        setOverlay(instance, rect);
                        // if lineFocusCoords are set, create a second overlay
                        if (props.lineFocusCoords) {
                            const lsc = getScalarCoordinates(props.lineFocusCoords, d.data.height, d.data.width);
                            const linerect = new openseadragon_1.default.Rect(lsc.x, lsc.y, lsc.w, lsc.h);
                            setOverlay(instance, linerect);
                        }
                        setGoHome(instance, rect);
                        instance.viewport.fitBounds(rect);
                    }
                    // if constrainViewerToCoords is true (not default) only set overlay boundaries
                    else {
                        // reset viewer to adjust surface dimensions rather than coordinate dimensions
                        setViewerWidthHeight(computeViewerWidthHeight(d.data.width, d.data.height));
                        // set overaly
                        setOverlay(instance, rect);
                    }
                }
                // since there are no coordinates, it computes required viewer height based on dimensions of entire image
                else {
                    setViewerWidthHeight(computeViewerWidthHeight(d.data.width, d.data.height));
                }
            }
            // if an OSD instance is not yet created, then create one
            else {
                try {
                    const id = "osd-" + viewerId;
                    const instance = (0, openseadragon_1.default)({
                        id: id,
                        prefixUrl: "https://openseadragon.github.io/openseadragon/images/",
                        preserveViewport: true,
                        visibilityRatio: 1,
                        minZoomLevel: props.defaultZoomLevel,
                        defaultZoomLevel: props.defaultZoomLevel,
                        tileSources: [d.data],
                        controlsFadeDelay: 0,
                        controlsFadeLength: 25
                    });
                    // if coords are present calculate coord rect
                    if (props.coords) {
                        // this should be another way to get Scalar coordinates, but it doesn't seem to be working
                        //const newRect = instance.viewport.imageToViewportRectangle(x, y, w, h)
                        const sc = getScalarCoordinates(props.coords, d.data.height, d.data.width);
                        const rect = new openseadragon_1.default.Rect(sc.x, sc.y, sc.w, sc.h);
                        // if constrainViewerToCoords is false (default) constrain view to coordinate region
                        if (!props.constrainViewerToCoords) {
                            setBounds(instance, rect);
                            setOverlay(instance, rect);
                            // if lineFocusCoords are set, create a second overlay
                            if (props.lineFocusCoords) {
                                const lsc = getScalarCoordinates(props.lineFocusCoords, d.data.height, d.data.width);
                                const linerect = new openseadragon_1.default.Rect(lsc.x, lsc.y, lsc.w, lsc.h);
                                setOverlay(instance, linerect);
                            }
                            setGoHome(instance, rect);
                        }
                        // if constrainViewerToCoords is true (not default) only set overlay boundaries
                        else {
                            setOverlay(instance, rect);
                            // reset viewer to adjust surface dimensions rather than coordinate dimensions
                            setViewerWidthHeight(computeViewerWidthHeight(d.data.width, d.data.height));
                        }
                    }
                    // since there are no coordinates, it computes required viewer height based on dimensions of entire image
                    else {
                        setViewerWidthHeight(computeViewerWidthHeight(d.data.width, d.data.height));
                    }
                    setInstance(instance);
                }
                catch (err) {
                    console.log("error loading OSD", err);
                }
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.imageurl, props.coords]);
    const setOverlay = (instance, rect) => {
        instance.addHandler("open", function () {
            const id = (0, uuid_1.v4)();
            const elt = document.createElement("div");
            elt.id = "runtime-overlay-" + id;
            elt.className = "osdhighlight";
            instance.addOverlay({
                element: elt,
                location: rect
            });
        });
    };
    const setBounds = (instance, rect) => {
        instance.addHandler("open", function () {
            instance.viewport.fitBounds(rect, true);
        });
    };
    const setGoHome = (instance, rect) => {
        //OpenSeadragon.Viewport.prototype.goHome = function () {
        instance.viewport.goHome = function () {
            // Give it whatever rectangle you want
            this.fitBounds(rect);
        };
    };
    const getScalarCoordinates = (inputCoords, imageH, imageW) => {
        const coords = inputCoords.split(",");
        const x = parseInt(coords[0]);
        const y = parseInt(coords[1]);
        const w = parseInt(coords[2]);
        const h = parseInt(coords[3]);
        const ar = imageH / imageW;
        const xcomp = x / imageW;
        const ycomp = (y / imageH) * ar;
        const wcomp = w / imageW;
        const hcomp = (h / imageH) * ar;
        return { x: xcomp, y: ycomp, w: wcomp, h: hcomp };
    };
    const computeViewerWidthHeight = (w, h) => {
        // compute new Height if coords are set or if prop.viewerHeight is null (which is default)
        const newHeight = (props.coords || !props.viewerHeight) ? props.viewerWidth * (parseInt(h) / parseInt(w)) : props.viewerHeight;
        return props.viewerFullWindow ? { w: "100%", h: "100vh" } : { w: props.viewerWidth + "px", h: newHeight + "px" };
    };
    return (react_1.default.createElement("div", { id: "osd-" + viewerId, className: "open-seadragon-container", style: { height: viewerWidthHeight.h, width: viewerWidthHeight.w } }));
};
exports.OSDInstance = OSDInstance;
OSDInstance.defaultProps = {
    imageurl: "https://loris2.scta.info/vat/V145v.jpg",
    defaultZoomLevel: 0,
    viewerWidth: 1000,
    viewerFullWindow: false,
    constrainViewerToCoords: false
};
OSDInstance.propTypes = {
    /**
    * @description imageurl (without iiif parameters) for which logo will be requested
    **/
    imageurl: prop_types_1.default.string.isRequired,
    /**
    * @description a comma separated string indicated coordinates in the following pattern x,y,w,h (follows the IIIF coord pattern)
    **/
    coords: prop_types_1.default.string,
    /**
     * @description determines initial zoom level; doesn't have any effect when coords are set, because zoom level is set by focused coordinate region
     */
    defaultZoomLevel: prop_types_1.default.number,
    /**
     * @description default setting for viewer height is null; when null it is computed from prop.viewerWidth;
     * Nor does it have an effect when coords are set, since viewer height it set by coordinate region and desired viewer width
     * @default null
     */
    viewerHeight: prop_types_1.default.number,
    /**
     * @description default setting for viewer width; default is 1000
     * @default 1000
     */
    viewerWidth: prop_types_1.default.number,
    /**
     * @description if set to true this overrides any viewer height/width computation sets viewer to height: 100vh and width to 100%; default is false
     * @default false
     */
    viewerFullWindow: prop_types_1.default.bool,
    /**
     * @description when coords are set this boolean determines whether the viewer should be contstrained to those coordinates
     * or if the viewer should be calculated on the basis of the full surface size.
     * @default false
     */
    constrainViewerToCoords: prop_types_1.default.bool
};
//# sourceMappingURL=osd-instance.js.map